import { IProfessionalSituationResource } from "../../professional-situations";
import { createApiQueryHook, IApiQueryFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";

export interface IProfessionalSituationQueryParameters {
    professionalSituation?: RelationalValue<IProfessionalSituationResource>;
}

export type IProfessionalSituationQueryResult = IProfessionalSituationResource;

export const professionalSituationQuery: IApiQueryFunction<IProfessionalSituationQueryParameters> = ({
    professionalSituation,
}) => {
    if (!professionalSituation) {
        return undefined;
    }

    return {
        method: "GET",
        url: `/professional_situations/${mapRelationalValue(professionalSituation)}`,
    };
};

export const useProfessionalSituationQuery = createApiQueryHook<
    IProfessionalSituationQueryParameters,
    IProfessionalSituationQueryResult
>(professionalSituationQuery);
